import '../../../sass/pages/_welcome-message.scss';


export default function EventMessage() {
    window.scrollTo(0, 0);

    return (

        <div className="event-message">
            <h1>Registration for this event is closed</h1>
            <p>Please check back for further updates</p>
        </div>
        
    )
}